export enum DIALOG_TYPES {
  CREATE,
  EDIT,
  RESIZE,
  DELETE,
  DOWNLOAD_RDP_FILE,
  STOP,
  SHELVE,
  SOFT_REBOOT,
  ASSOCIATE_FLOATING_IP,
  DISASSOCIATE_FLOATING_IP
}

export enum NET_PORT_BUTTONS {
  NETWORKS = "networks",
  PORT = "port"
}

export const NET_PORT_LABELS = {
  [NET_PORT_BUTTONS.NETWORKS]: "Networks",
  [NET_PORT_BUTTONS.PORT]: "Port"
};
